import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/data/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-16 bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-base"></i>
              </span>
              <span className="text-sm font-bold text-foreground-900 whitespace-nowrap">
                AllChinaBuy<span className="text-primary-600"> Spreadsheet</span>
              </span>
            </div>
            <p className="mt-3 text-xs leading-relaxed text-foreground-600">
              {t("footer.disclaimer")}
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <Link to="/" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
              {t("nav.home")}
            </Link>
            <Link to="/spreadsheet-guide" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
              {t("nav.guide")}
            </Link>
            <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
              {t("nav.visitSite")}
            </a>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} {t("footer.rights")}</p>
          <p className="text-xs text-foreground-500">kaspreadsheet.com</p>
        </div>
      </div>
    </footer>
  );
}